<template>
  <div id="sac-table-footer-container">
    <div :class="[
    'sac-tf-total',
    dark ? 'dark': ''
    ]">
      <span v-if="!loading">
        {{ totalRecords }} Records
      </span>
      <span v-else>
        Loading...
      </span>
    </div>

    <div class="sac-tf-right-container">
      <div class="sac-tf-row-count-container">
        <button
          ref="sac-tf-rc-prev"
          :class="[
            rowCount === 25 ? 'disabled' : '',
            'sac-tf-rc-button',
            rowCount !== 25 && dark ? 'dark' : ''
          ]"
          :disabled="rowCount === 25"
          @click.prevent="handleChangeRowCount(rowCount - 25, rowCount === 25)"
        >
          - 25
        </button>
        <div :class="[
        'sac-tf-row-count',
        dark ? 'dark' : ''
        ]">
          Amount Shown ({{ rowCount }})
        </div>
        <button
          ref="sac-tf-rc-next"
          :class="[
            rowCount === 100 ? 'disabled' : '',
            'sac-tf-rc-button',
            rowCount !== 100 && dark ? 'dark' : ''
          ]"
          :disabled="rowCount === 100"
          @click.prevent="handleChangeRowCount(rowCount + 25, rowCount === 100)"
        >
          + 25
        </button>
      </div>

      <div
        v-if="totalPage <= 8"
        class="sac-tf-pagination-container"
      >
        <button
          ref="sac-tf-p-first"
          :class="[
          'sac-tf-p-button',
          dark ? 'n40' : ''
          ]"
          :disabled="page === 1"
          @click="handlePrevNext(1, page === 1)"
        >
          <img src="@shared/assets/img/table/chevrons-left.svg">
        </button>
        <button
          ref="sac-tf-p-prev"
          :class="[
          'sac-tf-p-button',
          dark ? 'dark' : ''
          ]"
          :disabled="page === 1"
          @click="handlePrevNext(page - 1, page === 1)"
        >
          <img src="@shared/assets/img/table/chevron-left.svg">
        </button>
        <button
          v-for="pageNum in totalPage"
          :key="pageNum"
          :class="[
            'sac-tf-p-button',
            page === pageNum ? 'active' : '',
            page !== pageNum && dark ? 'dark' : ''
          ]"
          @click="changePage(pageNum)"
        >
          {{ pageNum }}
        </button>
        <button
          ref="sac-tf-p-next"
          :class="[
          'sac-tf-p-button',
           dark ? 'dark' : '' 
           ]"
          :disabled="page === totalPage"
          @click="handlePrevNext(page + 1, page === totalPage)"
        >
          <img src="@shared/assets/img/table/chevron-right.svg">
        </button>
        <button
          ref="sac-tf-p-last"
          :class="['sac-tf-p-button',
           dark ? 'dark' : '' ]"
          :disabled="page === totalPage"
          @click="handlePrevNext(totalPage, page === totalPage)"
        >
          <img src="@shared/assets/img/table/chevrons-right.svg">
        </button>
      </div>

      <!-- PAGINATION FOR TABLE MORE THAN 7 PAGE -->
      <div
        v-else
        class="sac-tf-pagination-container"
      >
        <button
          ref="sac-tf-p-first"
          :class="[
          'sac-tf-p-button',
           dark ? 'dark' : '' ]"
          :disabled="page === 1"
          @click="handlePrevNext(1, page === 1)"
        >
          <img src="@shared/assets/img/table/chevrons-left.svg">
        </button>
        <button
          ref="sac-tf-p-prev"
          :class="[
          'sac-tf-p-button',
           dark ? 'dark' : '' 
           ]"
          :disabled="page === 1"
          @click="handlePrevNext(page - 1, page === 1)"
        >
          <img src="@shared/assets/img/table/chevron-left.svg">
        </button>
        <button
          :class="[
            'sac-tf-p-button',
            page === 1 ? 'active' : '', 
            page !== 1 && dark ? 'dark' : '' 
          ]"
          @click="changePage(1)"
        >
          1
        </button>
        <button
          v-if="page > 4"
          :class="[
          'sac-tf-p-button',
          dark ? 'dark' : '' 
          ]"
          disabled="true"
        >
          ...
        </button>
        <button
          v-if="page <= 4"
          :class="[
            page === page + 1 ? 'active' : '',
            page === 2 ? 'active' : '',
            !(page === 2  || page === page + 1) && dark ? 'dark' : '',
            'sac-tf-p-button',
          ]"
          @click="changePage(2)"
        >
          2
        </button>
        <button
          :class="[
          'sac-tf-p-button',
            page === 3 ? 'active' : '',
            page === page - 2 && totalPage - page <= 7 ? 'active' : '',
            page === totalPage - 6 ? 'active' : '',
            !(page === 3 || (page === page - 2 && totalPage - page <= 7) || page === totalPage - 6) && dark ? 'dark' : '',
          ]"
          @click="handleChangePage(0)"
        >
          <span v-if="page <= 4">
            3
          </span>
          <span v-else-if="totalPage - page > 7">
            {{ page - 2 }}
          </span>
          <span v-else>
            {{ totalPage - 6 }}
          </span>
        </button>
        <button
          :class="[
          'sac-tf-p-button',
            page === 4 ? 'active' : '',
            page === page - 1 && totalPage - page <= 7 ? 'active' : '',
            page === totalPage - 5 ? 'active' : '',
            !(page === 4 || (page === page - 1 && totalPage - page <= 7) || page === totalPage - 5) && dark ? 'dark' : '',
          ]"
          @click="handleChangePage(1)"
        >
          <span v-if="page <= 4">
            4
          </span>
          <span v-else-if="totalPage - page > 7">
            {{ page - 1 }}
          </span>
          <span v-else>
            {{ totalPage - 5 }}
          </span>
        </button>
        <button
          :class="[
           'sac-tf-p-button',
            page === 5 ? 'active' : '',
            page > 4 && totalPage - page >= 7 ? 'active' : '',
            page === totalPage - 4 ? 'active' : '',
            !(page === 5 || (page > 4 && totalPage - page >= 7) || page === totalPage - 4) && dark ? 'dark' : ''
          ]"
          @click="handleChangePage(2)"
        >
          <span v-if="page <= 4">
            5
          </span>
          <span v-else-if="totalPage - page >= 7">
            {{ page }}
          </span>
          <span v-else>
            {{ totalPage - 4 }}
          </span>
        </button>
        <button
          :class="[
            'sac-tf-p-button',
            page === page + 1 && totalPage - page < 7 ? 'active' : '',
            page === totalPage - 3 ? 'active' : '',
            !((page === page + 1 && totalPage - page < 7) || (page === totalPage - 3)) && dark ? 'dark' : '',
          ]"
          @click="handleChangePage(3)"
        >
          <span v-if="page <= 4">
            6
          </span>
          <span v-else-if="totalPage - page >= 7">
            {{ page + 1 }}
          </span>
          <span v-else>
            {{ totalPage - 3 }}
          </span>
        </button>
        <button
          :class="[
            'sac-tf-p-button',
            page === page + 2 && totalPage - page < 7 ? 'active' : '',
            page === totalPage - 2 ? 'active' : '',
            !(page === totalPage - 2 || (page === page + 2 && totalPage - page < 7)) && dark ? 'dark' : '',
          ]"
          @click="handleChangePage(4)"
        >
          <span v-if="page <= 4">
            7
          </span>
          <span v-else-if="totalPage - page >= 7">
            {{ page + 2 }}
          </span>
          <span v-else>
            {{ totalPage - 2 }}
          </span>
        </button>
        <button
          v-if="totalPage - page < 7"
          :class="[
            'sac-tf-p-button',
            page === totalPage - 1 ? 'active' : (page === totalPage - 1 && dark ? 'active' : (!dark ? '' : 'dark'))
          ]"
          @click="changePage(totalPage - 1)"
        >
          {{ totalPage - 1 }}
        </button>
        <button
          v-if="totalPage - page >= 7"
          type="button"
          :class="[
          'sac-tf-p-button',
          dark ? 'dark' : ''
          ]"
          disabled="true"
        >
          ...
        </button>
        <button
          :class="[
          'sac-tf-p-button',
            page === totalPage ? 'active' : '',
            page !== totalPage && dark ? 'dark' : '',
          ]"
          @click="changePage(totalPage)"
        >
          {{ totalPage }}
        </button>
        <button
          ref="sac-tf-p-next"
          :class="[
          'sac-tf-p-button',
          dark ? 'dark' : '',
          ]"
          :disabled="page === totalPage"
          @click="handlePrevNext(page + 1, page === totalPage)"
        >
          <img src="@shared/assets/img/table/chevron-right.svg">
        </button>
        <button
          ref="sac-tf-p-last"
          :class="['sac-tf-p-button',
          dark ? 'dark' : '',
          ]"
          :disabled="page === totalPage"
          @click="handlePrevNext(totalPage, page === totalPage)"
        >
          <img src="@shared/assets/img/table/chevrons-right.svg">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SACTableFooter',
  props: {
    totalRecords: Number,
    rowCount: Number,
    page: Number,
    totalPage: Number,
    changeRowCount: Function,
    changePage: Function,
    loading: Boolean,
    dark: Boolean,
  },
  created() {
    this.handleChangePage = _.throttle(this.handleChangePage, 200);
    this.handlePrevNext = _.debounce(this.handlePrevNext, 800);
  },
  methods: {
    handleChangeRowCount(count, disabled) {
      if (!disabled) {
        this.changeRowCount(count);
      }
      if (this.$refs['sac-tf-rc-prev']) {
        this.$refs['sac-tf-rc-prev'].blur();
      }
      if (this.$refs['sac-tf-rc-next']) {
        this.$refs['sac-tf-rc-next'].blur();
      }
    },
    handlePrevNext(page, disabled) {
      if (!disabled) {
        this.changePage(page);
      }
      if (this.$refs['sac-tf-p-first']) {
        this.$refs['sac-tf-p-first'].blur();
      }
      if (this.$refs['sac-tf-p-prev']) {
        this.$refs['sac-tf-p-prev'].blur();
      }
      if (this.$refs['sac-tf-p-next']) {
        this.$refs['sac-tf-p-next'].blur();
      }
      if (this.$refs['sac-tf-p-last']) {
        this.$refs['sac-tf-p-last'].blur();
      }
    },
    handleChangePage(index) {
      const {
        page,
        totalPage,
        changePage,
      } = this;
      switch (index) {
        case 0: {
          if (page <= 4) {
            changePage(3);
          } else if (totalPage - page >= 7) {
            changePage(page - 2);
          } else {
            changePage(totalPage - 6);
          }
          break;
        }
        case 1: {
          if (page <= 4) {
            changePage(4);
          } else if (totalPage - page >= 7) {
            changePage(page - 1);
          } else {
            changePage(totalPage - 5);
          }
          break;
        }
        case 2: {
          if (page <= 4) {
            changePage(5);
          } else if (totalPage - page >= 7) {
            changePage(page);
          } else {
            changePage(totalPage - 4);
          }
          break;
        }
        case 3: {
          if (page <= 4) {
            changePage(6);
          } else if (totalPage - page >= 7) {
            changePage(page + 1);
          } else {
            changePage(totalPage - 3);
          }
          break;
        }
        case 4: {
          if (page <= 4) {
            changePage(6);
          } else if (totalPage - page >= 7) {
            changePage(page + 2);
          } else {
            changePage(totalPage - 2);
          }
          break;
        }
        default: break;
      }
    },
  },
};
</script>

<style lang="scss">

#sac-table-footer-container {
  margin-top: 18px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .sac-tf-total {
    color: $BLACK;
    font-size: 1rem;
    font-weight: 500;
    &.dark {
       color: $N50,
    }
  }
  .sac-tf-right-container {
    display: flex;
    align-items: center;
    .sac-tf-row-count-container {
      display: flex;
      align-items: center;
      height: 32px;
      margin-right: 64px;
      .sac-tf-row-count {
        color: $BLACK;
        font-size: 0.889rem;
        font-weight: 500;
        width: 160px;
        text-align: center;
        &.dark {
          color: $N50,
        }
      }
      .sac-tf-rc-button {
        width: 62px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 0.889rem;
        font-weight: 500;
        &:hover {
          background-color: $N10;
        }
        &:focus {
          background-color: $N20;
        }
        &:disabled {
          background-color: transparent;
          opacity: 0.2;
        }
        &.dark {
          color: $N50;
        }
      }
    }
    .sac-tf-pagination-container {
      display: flex;
      .sac-tf-p-button {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 0.889rem;
        img {
          width: 10px;
          height: 10px;
        }
        &:not(:first-child) {
          margin-left: 4px;
        }
        &:hover {
          background-color: $N10;
        }
        &:focus {
          background-color: $N20;
        }
        &:disabled {
          background-color: transparent;
          opacity: 0.2;
        }
        &.active {
          background-color: $NBLUE100;
          color: $WHITE;
          font-weight: 700;
        }
        &.dark {
          background-color: $N90;
          color: $N50;
        }
      }
    }
  }
}
</style>
